const WSG_STATUS = {
  EN_PREPARACION: "PRE",
  LISTO_PARA_RETIRAR: "RET",
  RETIRADO: "REO",
  EN_RUTA_DE_ENTREGA: "RUT",
  ENTREGADO: "ENT",
  NO_ENTREGADO: "NEN",
  CANCELADO: "CAN",
};

module.exports = {
  WSG_STATUS,
};
